import { itemCreateModalFormInitialValues } from 'components/ItemBaseModalForm'

import { SaveItemFormFields } from './InvoiceItemCreateModal.types'

export const initialValues: SaveItemFormFields = {
  index: 0,
  ...itemCreateModalFormInitialValues,
}
